import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';

import styles from './Frequency.module.css';
import FrequencyLine from './FrequencyLine';

const labelsArray = ['Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr'];
const dataArray = [1, 2, 3, 4, 5, 6];

const tempData = {
  labels: ['Nov21', 'Dec21', 'Jan22'],
  datasets: [
    {
      label: 'Total Posts TEMP',
      data: [5, 5, 5],
      borderColor: '#00917C',
      backgroundColor: '#00917C',
    },
  ],
};

const tempMediaData = {
  labels: ['Nov21', 'Dec21', 'Jan22'],
  datasets: [
    {
      label: 'Pencil',
      data: [13, 15, 6],
      borderColor: '#5D534A',
      backgroundColor: '#5D534A',
    },
    {
      label: 'Pen',
      data: [6, 23, 2],
      borderColor: '#0A81AB',
      backgroundColor: '#0A81AB',
    },
    {
      label: 'Wash',
      data: [34, 5, 23],
      borderColor: '#BB371A',
      backgroundColor: '#BB371A',
    },
    {
      label: 'Color',
      data: [7, 69, 65],
      borderColor: '#EBA83A',
      backgroundColor: '#EBA83A',
    },
    {
      label: 'Paint',
      data: [1, 18, 32],
      borderColor: '#8B5E83',
      backgroundColor: '#8B5E83',
    }
  ],
};

const tempLikesData = {
  labels: [],
  datasets: [
    {
      label: 'Posts by Likes',
      data: [],
      borderColor: '#9D84B7',
      backgroundColor: '#9D84B7',
    },
  ],
};

const Frequency = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(tempData);
  const [totalData, setTotalData] = useState(tempData);
  const [mediaData, setMediaData] = useState(tempMediaData);
  const [likesData, setLikesData] = useState(tempLikesData);
  const [monthlyLabel, setMonthlyLabel] = useState();
  const [monthlyData, setMonthlyData] = useState();
  const [ready, setReady] = useState(false);
  const [mediaReady, setMediaReady] = useState(false);
  const [frMode, setFrMode] = useState('0');

  useEffect(()=> {
    if (frMode === '0') {
      setData(totalData);
    } else if (frMode === '1') {
      setData(mediaData);
    } else {
      setData(likesData);
    }
    console.log(frMode);
  },[frMode, totalData, mediaData, likesData]);

  // useEffect(()=> {
  //   setIsLoading(false);
  //   setReady(true);
  // },[data]);

  useEffect(() => {
    if (props.loadedStickies) {
      calcFrequency(props.loadedStickies);
    }
  }, [props.loadedStickies]);
  
  const calcFrequency = (ls) => {
    let monthlyFrequencyArray = [];
    // let dailyFrequencyArray = [];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const posts = [];

    ls.forEach((i) => {
      const newObj = {
        month: months[new Date(i.date).getMonth()] + ((new Date(i.date).getFullYear()) - 2000),
        day: new Date(i.date).getDate(),
        count: 1,
      };
      monthlyFrequencyArray.push(newObj);
    });

    // let catArray = [];
    // ls.forEach((item) => {
    //   // console.log(item);
    //   item.tags.forEach((i) => {
    //     const catThere = (catArray) => catArray.category === i;
    //     const testCat = catArray.some(catThere);
    //     if (!testCat) {
    //       // console.log('not there!');
    //       catArray.push({ category: i, count: 1 });
    //     } else {
    //       // console.log('already there!');
    //       const catId = catArray.map((e) => e.category).indexOf(i);
    //       // console.log(catId);
    //       const getEntry = catArray[catId];
    //       const newEntry = { ...catArray[catId], count: getEntry.count + 1 };
    //       catArray.splice(catId, 1, newEntry);
    //     }
    //   });
    // });

    // calc How many posts in each month per media. 1 labels, 5 datasets

    let monthlyMediaArray = [];
    let mediaObjectArray = [];

    // ls.forEach((item) => {
    //   // console.log(item);
    //   item.media.forEach((i) => {
    //     const mediaThere = (mediaArray) => mediaArray.category === i;
    //     const testMedia = mediaArray.some(mediaThere);
    //     if (!testMedia) {
    //       // console.log('not there!');
    //       mediaArray.push({ category: i, count: 1 });
    //     } else {
    //       // console.log('already there!');
    //       const catId = catArray.map((e) => e.category).indexOf(i);
    //       // console.log(catId);
    //       const getEntry = catArray[catId];
    //       const newEntry = { ...catArray[catId], count: getEntry.count + 1 };
    //       catArray.splice(catId, 1, newEntry);
    //     }
    //   });
    // });

    // const crayonArray = ls.forEach(i => {
    //   console.log(i)
    //   i.media.forEach(m => {
    //     console.log(m)
    //     m.includes('pencil') ? m.replace('pencil', 'crayon') : console.log('no change');
    //     console.log(m);
    //   });
    // });

    // console.log('crayonArray', crayonArray);

    ls.forEach((i) => {

      let pencil = 0;
      let pen = 0;
      let wash = 0;
      let color = 0;
      let paint = 0;

      i.media.forEach(m => {
        m === 'pencil' ? pencil = 1 : pencil = 0;
        m === 'pen' ? pen = 1 : pen = 0;
        m === 'wash' ? wash = 1 : wash = 0;
        m === 'color' ? color = 1 : color = 0;
        m === 'paint' ? paint = 1 : paint = 0;
        });

      const newMediaObj = {
        month: months[new Date(i.date).getMonth()] + ((new Date(i.date).getFullYear()) - 2000),
        pencil,
        pen,
        wash,
        color,
        paint
      };
      monthlyMediaArray.push(newMediaObj);
    });

    // console.log('monthlyMediaArray', monthlyMediaArray);

    monthlyMediaArray.forEach((item) => {
      const monthThere = (mediaObjectArrays) => mediaObjectArrays.month === item.month;
      const testMonth = mediaObjectArray.some(monthThere);
      // console.log(objectArrays.month, 'VS', item.month).getMonth()]);
      // console.log(testMonth);
      if (!testMonth) {
        // console.log('not there!');
        // console.log('no: ', item);
        mediaObjectArray.push({ month: item.month, pencil: item.pencil, pen: item.pen, wash: item.wash, color: item.color, paint: item.paint });
        // objectArrays.push({ month: months[new Date(item.month).getMonth()], likes: 0 });
      } else {
        // console.log('already there!');
        const monthId = mediaObjectArray.map((e) => e.month).indexOf(item.month);
        // console.log('yes: ', item);
        // console.log('monthId', monthId);
        // console.log('OA', objectArrays);
        const getEntry = mediaObjectArray[monthId];
        const newEntry = { ...mediaObjectArray[monthId], pencil: getEntry.pencil + item.pencil, pen: getEntry.pen + item.pen, wash: getEntry.wash + item.wash, color: getEntry.color + item.color, paint: getEntry.paint + item.paint};
        // console.log('newEntry', newEntry);
        mediaObjectArray.splice(monthId, 1, newEntry);
      }
    });
    // console.log('moa', mediaObjectArray);

    


    // console.log('MONTHLIKES-LABELS: ', likesMonthLabels);
    // console.log('MONTHLIKES-DATA: ', likesMonthData);


    const mediaMonthLabels = mediaObjectArray.map(i => i.month);

    mediaMonthLabels.splice(0, 2);

    // console.log('mediaMonthLabels', mediaMonthLabels);

    const pencilMonthData = mediaObjectArray.map(i => i.pencil);
    const penMonthData = mediaObjectArray.map(i => i.pen);
    const washMonthData = mediaObjectArray.map(i => i.wash);
    const colorMonthData = mediaObjectArray.map(i => i.color);
    const paintMonthData = mediaObjectArray.map(i => i.paint);

    pencilMonthData.splice(0, 2);
    penMonthData.splice(0, 2);
    washMonthData.splice(0, 2);
    colorMonthData.splice(0, 2);
    paintMonthData.splice(0, 2);
    

    // calc How many likes in each month. 1 labels 1 dataset

    // const likesMonthLabels = objectArrays.map((i) => i.month);
    // const likesMonthData = objectArrays.map((i) => i.likes);

    const likesPosts = [];
    const monthObjects = [];

    ls.forEach((i) => {
      const newObj = {
        month: months[new Date(i.date).getMonth()] + ((new Date(i.date).getFullYear()) - 2000),
        likes: i.likes
      };
      monthObjects.push(newObj);
    });
    // console.log('MAL!', monthObjects);

    let objectArrays = [];
    monthObjects.forEach((item) => {
      const monthThere = (objectArrays) => objectArrays.month === item.month;
      const testMonth = objectArrays.some(monthThere);
      // console.log(objectArrays.month, 'VS', item.month).getMonth()]);
      // console.log(testMonth);
      if (!testMonth) {
        // console.log('not there!');
        // console.log('no: ', item);
        objectArrays.push({ month: item.month, likes: 1 });
        // objectArrays.push({ month: months[new Date(item.month).getMonth()], likes: 0 });
      } else {
        // console.log('already there!');
        const monthId = objectArrays.map((e) => e.month).indexOf(item.month);
        // console.log('yes: ', item);
        // console.log(monthId);
        // console.log('OA', objectArrays);
        const getEntry = objectArrays[monthId];
        const newEntry = { ...objectArrays[monthId], likes: getEntry.likes + item.likes };
        objectArrays.splice(monthId, 1, newEntry);
      }
    });
    // console.log('oa' + objectArrays);
    const likesMonthLabels = objectArrays.map((i) => i.month);
    const likesMonthData = objectArrays.map((i) => i.likes);

    likesMonthLabels.splice(0, 2);
    likesMonthData.splice(0, 2);

    // console.log('MONTHLIKES-LABELS: ', likesMonthLabels);
    // console.log('MONTHLIKES-DATA: ', likesMonthData);

    //

    let monthArray = [];
    monthlyFrequencyArray.forEach((item) => {
      const monthThere = (monthArray) => monthArray.month === item.month;
      const testMonth = monthArray.some(monthThere);
      if (!testMonth) {
        // console.log('not there!');
        monthArray.push({ month: item.month, count: 1 });
      } else {
        // console.log('already there!');
        const monthId = monthArray.map((e) => e.month).indexOf(item.month);
        // console.log(monthId);
        const getEntry = monthArray[monthId];
        const newEntry = { ...monthArray[monthId], count: getEntry.count + 1 };
        monthArray.splice(monthId, 1, newEntry);
      }
    });

    const monthLabels = monthArray.map((i) => i.month);
    const monthData = monthArray.map((i) => i.count);

    monthLabels.splice();
    monthData.splice();

    const updatedTotalData = {
      labels: monthLabels,
      datasets: [
        {
          label: 'Total Posts',
          data: monthData,
          borderColor: '#00917C',
          backgroundColor: '#00917C',
        },
      ],
    };

    setTotalData((prevState) => updatedTotalData);

    const updatedMediaData = {
      labels: mediaMonthLabels,
      datasets: [
        {
          label: 'Pencil',
          data: pencilMonthData,
          borderColor: '#5D534A',
          backgroundColor: '#5D534A',
        },
        {
          label: 'Pen',
          data: penMonthData,
          borderColor: '#0A81AB',
          backgroundColor: '#0A81AB',
        },
        {
          label: 'Wash',
          data: washMonthData,
          borderColor: '#BB371A',
          backgroundColor: '#BB371A',
        },
        {
          label: 'Color',
          data: colorMonthData,
          borderColor: '#EBA83A',
          backgroundColor: '#EBA83A',
        },
        {
          label: 'Paint',
          data: paintMonthData,
          borderColor: '#8B5E83',
          backgroundColor: '#8B5E83',
        }
      ],
    };

    setMediaData((prevState) => updatedMediaData);

    const updatedLikesData = {
      labels: likesMonthLabels,
      datasets: [
        {
          label: 'Posts by Likes',
          data: likesMonthData,
          borderColor: '#9D84B7',
          backgroundColor: '#9D84B7',
        },
      ],
    };

    setLikesData((prevState) => updatedLikesData);

    setIsLoading(false);
    setReady(true);

  };

  const modeHandler = (e) => {
    // console.log(e.target.id);
    setFrMode(e.target.id);
  };

  return (
    <div className={styles.frequencyContainer}>
      <h2>post frequency:</h2>
      {isLoading && (
        <div className={styles.freqencyLineDiv}>
          <LoadingSpinner />
        </div>
      )}
      {!isLoading && (
        <div>
          {(
            <div className={styles.freqencyLineDiv}>
              <FrequencyLine
              data={data}
              ready={ready}
              />
            </div>
          )}
        </div>
      )}
      <div className={styles.frBtnGroup} onClick={modeHandler}>
        <button
          id={'0'}
          className={frMode === '0' ? styles.frBtnActive : styles.frBtn}
        >
          Total Posts
        </button>
        <button
          id={'1'}
          className={frMode === '1' ? styles.frBtnActive : styles.frBtn}
        >
          By Media
        </button>
        <button
          id={'2'}
          className={frMode === '2' ? styles.frBtnActive : styles.frBtn}
        >
         By Likes
        </button>
      </div>
    </div>
  );
};

export default Frequency;
